// extracted by mini-css-extract-plugin
export default {"placeholder":"placeholder--mqOR6","pulse":"pulse--t0K9x"};